import { render, staticRenderFns } from "./df-page-coupon-details.vue?vue&type=template&id=45d43908&scoped=true"
import script from "./df-page-coupon-details.ts?vue&type=script&lang=js&external"
export * from "./df-page-coupon-details.ts?vue&type=script&lang=js&external"
import style0 from "./df-page-coupon-details.vue?vue&type=style&index=0&id=45d43908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d43908",
  null
  
)

export default component.exports